import { BootstrapContext } from '../actions/bootstrapActions';

export const isSellerContext = ({ bootstrap }) => {
    const { context } = bootstrap;
    return context === BootstrapContext.SELLER || context === BootstrapContext.PHYSICAL_GIFT_CARD;
};
